// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__Snp2d","label":"Chip_label__bS_2P","primary":"Chip_primary__rvlOb","primaryOutlined":"Chip_primaryOutlined__DHCWz","deleteControl":"Chip_deleteControl__jW_3A"};